import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import {
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@material-ui/core";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  round,
} from "../../util/varios";
import moment from "moment";

import useTableScroll from "../useTableScroll";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoMoneda from "../../catalogos/catalogoMoneda";
import CatalogoProducto from "../../catalogos/catalogoProducto";
import CatalogoOrdenCompras from "../../catalogos/catalogoOrdenesdCompra";
import RegistrarProveedor from "../../catalogos/catalogoAgregarProveedor";
import TablaRetenciones from "./tablaRetenciones";
import CatalogoFacturasdCompra from "../../catalogos/catalogoFacturasCompra";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";

const TablaFacturarOrdenCompra = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
  const usuario = JSON.parse(sessionStorage.getItem("login"));
  const accbtnfactucompra = JSON.parse(
    sessionStorage.getItem("accbtnfactucomprac")
  );

  const headCells = [
    { label: "COD/PRODUCTO", width: "0px" },
    { label: "PRODUCTO", textAlign: "center" },
    { label: "CNTD", textAlign: "center" },
    { label: "UNI.ALT.", textAlign: "center" },
    { label: "PRECIO PVDR.", textAlign: "center" },
    { label: "IVA", textAlign: "center" },
    { label: "MONTO IVA.", textAlign: "center" },
    { label: "MONTO TOTAL", textAlign: "center" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtNombreCliente = useRef();
  const txtSubTotal = useRef();
  const txtTotalIva = useRef();
  const txtTotalconIva = useRef();
  const txtTotal = useRef();
  const txtDirClient = useRef();
  const cmbRif = useRef();
  const txtIdfactura = useRef();
  const txtCantidad = useRef([]);
  const txtPrecio = useRef([]);
  const txtId = useRef([]);
  const txtCedRif = useRef();
  const txtCodigo = useRef();
  const txtTotalRetencion = useRef();
  const txtFecha = useRef();
  const txtExento = useRef();
  const txtAlmacen = useRef();
  const txtIdmoneda = useRef();
  const txtIdmonedados = useRef();
  const txtAfectaInventario = useRef();
  const txtOrdenCompra = useRef();
  const txtNumControl = useRef();
  const txtCodigoProducto = useRef();

  const [idCliente, setIdCliente] = useState("");
  const [datosfact, setDatosfact] = useState([]);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [desde, setDesde] = useState(0);
  const [catalogoPresu, setCatalogoPresu] = useState(false);
  const [catalogoFactura, setCatalogoFactura] = useState(false);
  const [catalogoalmacen, setCatalogoalmacen] = useState(false);
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Facturas de Compra."
  );
  const [numNota, setNumNota] = useState(null);
  const [tipou, setTipou] = useState(0);
  const [valalmacen, setValalmacen] = useState(0);
  const [rif, setRif] = useState(null);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [statusordencompra, setStatusordencompra] = useState(0);
  const [tasaor, setTasaor] = useState(0);
  const [records, setRecords] = useState([]);
  const [mostrar, setMostrar] = useState(false);
  const [consulp, setConsulp] = useState(true);
  const [habilitado, setHabilitado] = useState(true);
  const [items, setItems] = useState([]);
  const [idmoney, setIdmoney] = useState(0);
  const [datareten, setDatareten] = useState([]);
  const [datosret, setDatosret] = useState([]);
  const [body, setBody] = useState(null);
  const [catregistrarcliente, setCatregistrarcliente] = useState(false);
  const [combomoneda, setComboMoneda] = useState([]);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoMoneda, setCatalogoMoneda] = useState(false);
  const [valparametro, setValparametro] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [idorden, setIdorden] = useState(null);
  const [idalmacen, setIdAlmacen] = useState(0);
  const [indice, setIndice] = useState(null);
  const [idOpeInve, setIdOpeInve] = useState("");
  const [activate, setActivate] = useState(false);
  const [castabla, setCastabla] = useState(true);
  const [moneda, setMoneda] = useState({
    idmoneda: "4",
    descripcion: "DOLARES",
    simbolo: "$",
    predeterminada: true,
    valormoneda: 0.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "2",
    descripcion: "DOLARES",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 0.0,
  });
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });
  const [acpt, setAcpt] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead } = useTableScroll(headCells, filterFn);

  var opf =
    operacion === 0
      ? 0
      : operacion === 8
        ? 8
        : operacion === 4
          ? 4
          : operacion === 3
            ? 3
            : operacion === 1 && records.length === 0
              ? 1
              : operacion === 2 && records.length === 0
                ? 1
                : 2;

  const seleccionarAlmacen = (id, val) => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            if (val === 7) {
              txtAlmacen.current.value = response.data.idalmacen;
            } else {
              setIdAlmacen(response.data.idalmacen);
              txtAlmacen.current.value = response.data.idalmacen;
            }

          } else {
            setDesde(3);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Almacen de venta",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarIdProductoM = (index) => (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarEditarProducto(index, idalmacen, event.target.value);
      }
    }
  };

  const validarIdProducto = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProducto(idalmacen, event.target.value);
      }
    }
  };

  const editarProducto = (index) => (e) => {
    e.preventDefault();
    setMostrar(true);
    setIndice(index);
  };

  const agregarProducto = (producto) => {
    setMostrar(false);
    if (indice === null) {
      seleccionarProducto(idalmacen, producto.codigo);
    } else {
      seleccionarEditarProducto(indice, idalmacen, producto.codigo);
    }
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    var data = [...records];
    var elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
      }
    }
    setRecords(elementos);
    calcularTotales(elementos);
  };

  const seleccionarProducto = (idubi, idprod) => {

    let endpoint = `${op.conexion}/api/pedido/seleccionarproductoinv?idproducto=${idprod.toUpperCase()}&idalmacen=${idubi}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];

          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "El producto no existe o esta Inactivo",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "El PRODUCTO YA EXISTE",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];

              if (parseInt(response.data.idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data.idunidadalterna,
                    descripcion: response.data.descripcionunialt,
                    tipo: "alterna",
                  },
                ];
              }

              let precio = response.data.costoproveedor;

              let montoiva = (precio * response.data.ivaventa) / 100;

              data.push({
                idproducto: response.data.idproducto,
                codigo: response.data.codigo,
                cantidad: 1.0,
                nombrecorto: response.data.nombrecorto,
                precio: precio,
                iva: response.data.ivaventa,
                motoiva: montoiva,
                descuento: "",
                total: parseFloat(precio) + parseFloat(montoiva),
                totald: precio,
                unidad: uni,
                idunidadmedida: response.data.idunidadmedida,
                idunidadalterna: response.data.idunidadalterna,
                idmoneda: response.data.idmoneda,
                valormoneda: round(monedaSub.valormoneda, 2),
                tipounidad: 0,
                valorfactor: response.data.valorfactor,
                costoproveedor: response.data.costoproveedor,
                tipofactor: response.data.tipofactor,
              });
              setRecords(data);
              if (operacion === 1) {
                calcularTotales(data);
                setDatosfact([]);
                txtTotalRetencion.current.value = "";
              } else {
                setTipou(1);
                let subtot = 0.0,
                  totr = 0.0,
                  totalm = 0.0,
                  toivss = 0.0, totalexento = 0.0;

                for (let i = 0; i < data.length; i++) {
                  toivss = parseFloat(toivss) + data[i].motoiva;
                  subtot = parseFloat(subtot) + parseFloat(data[i].totald);
                  if (parseInt(data[i].iva) === 0) {
                    totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
                  }
                }

                totalm = subtot + toivss;
                txtSubTotal.current.value = formatMoneda(
                  subtot.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtExento.current.value = formatMoneda(
                  totalexento.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotalIva.current.value = formatMoneda(
                  toivss.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotalconIva.current.value = formatMoneda(
                  totalm.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotal.current.value = formatMoneda(
                  totalm.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );

                let ret = [...datosret];
                let info = [];
                info.push({
                  base: txtSubTotal.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  iva: response.data.ivaventa,
                  montoiva: txtTotalIva.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  totalc: txtTotal.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  id: ret.length > 0 ? ret[0].codigo : "",
                });
                setDatosfact(info);
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "El producto no existe o esta Inactivo",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtId.current.value = "";
        txtId.current.focus();
      });
  };

  const seleccionarEditarProducto = (index, idubi, idprod) => {

    let endpoint = `${op.conexion}/api/pedido/seleccionarproductoinv?idproducto=${idprod.toUpperCase()}&idalmacen=${idubi}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];

          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "El producto no existe o esta Inactivo",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "El PRODUCTO YA EXISTE",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];

              if (parseInt(response.data.idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data.idunidadalterna,
                    descripcion: response.data.descripcionunialt,
                    tipo: "alterna",
                  },
                ];
              }

              let precio = response.data.costoproveedor;

              precio = precio * response.data.valormoneda;
              precio = precio / moneda.valormoneda;

              let montoiva = (precio * response.data.ivaventa) / 100;

              data[index] = {
                idproducto: response.data.idproducto,
                codigo: response.data.codigo,
                cantidad: 1.0,
                cantidadE: response.data.cantidad,
                nombrecorto: response.data.nombrecorto,
                precio: precio,
                iva: response.data.ivaventa,
                motoiva: montoiva,
                descuento: "",
                total: precio + montoiva,
                totald: precio,
                unidad: uni,
                idunidadmedida: response.data.idunidadmedida,
                idunidadalterna: response.data.idunidadalterna,
                idmoneda: response.data.idmoneda,
                valormoneda: response.data.valormoneda,
                valorfactor: response.data.valorfactor,
                costoproveedor: response.data.costoproveedor,
                tipofactor: response.data.tipofactor,
              };
              setIndice(null);
              setRecords(data);
              if (operacion === 1) {
                calcularTotales(data);
                setDatosfact([]);
                txtTotalRetencion.current.value = "";
              } else {
                setTipou(1);
                let subtot = 0.0,
                  totr = 0.0,
                  totalm = 0.0,
                  toivss = 0.0, totalexento = 0.0;

                for (let i = 0; i < data.length; i++) {
                  toivss = parseFloat(toivss) + data[i].motoiva;
                  subtot = parseFloat(subtot) + data[i].totald;
                  if (parseInt(data[i].iva) === 0) {
                    totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
                  }
                }

                totalm = subtot + toivss;
                txtSubTotal.current.value = formatMoneda(
                  subtot.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtExento.current.value = formatMoneda(
                  totalexento.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotalIva.current.value = formatMoneda(
                  toivss.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotalconIva.current.value = formatMoneda(
                  totalm.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );
                txtTotal.current.value = formatMoneda(
                  totalm.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                );

                let ret = [...datosret];
                let info = [];
                info.push({
                  base: txtSubTotal.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  iva: response.data.ivaventa,
                  montoiva: txtTotalIva.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  totalc: txtTotal.current.value
                    .replace(/\./g, "")
                    .replace(",", "."),
                  id: ret.length > 0 ? ret[0].codigo : "",
                });
                setDatosfact(info);
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "El producto no existe o esta Inactivo",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtId.current.value = "";
        txtId.current.focus();
      });
  };

  const seleccionarDetalleOrdenCompra = (id) => {
    let endpoint = `${op.conexion}/api/ordencompra/seleccionarordencompra?idordendecompra=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {

            var prod = [];

            let uni = [];
            let precio = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let tasa = 0.0;

              if (statusordencompra === 1) {
                tasa = tasaor;
              } else {
                tasa = response.data[i].valormoneda;
              }

              let mont = round((response.data[i].punitario * response.data[i].ivaventa) / 100, 2);

              precio = response.data[i].punitario;

              let montoiva = mont;
              montoiva = montoiva * response.data[i].cantidad;

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                nombrecorto: response.data[i].nombrecorto,
                precio: precio,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                motoiva: montoiva,
                descuento: response.data[i].descuento,
                total: round(precio * response.data[i].cantidad, 2) + montoiva,
                totald: response.data[i].cantidad * precio,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: response.data[i].valormoneda,
                idmoneda: response.data[i].idmoneda,
                costoproveedor: response.data[i].punitario,
                tasa: tasa,
                valorfactor: response.data[i].valorfactor,
                tipofactor: response.data[i].tipofactor,
              });
            }
            setRecords(prod);
            calcularTotales(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalleFactura = (id, data, tasav, idope) => {
    let endpoint = `${op.conexion}/api/retenciones/consultarcompra?idfacturacompra=${id}&idope=${idope}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {

          if (response.data.length > 0 && data.length > 0) {
            var prod = [];
            let ret = [...data];
            let rets = [];
            let uni = [];
            let precio = 0.0;

            for (let c = 0; c < ret.length; c++) {
              rets.push({ total: ret[c].total });
            }

            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let tasa = 0.0;

              if (operacion !== 1) {
                tasa = tasav;
              } else {
                tasa = response.data[i].valormoneda;
              }

              let mont = round((response.data[i].punitario * response.data[i].ivaventa) / 100, 2);

              precio = response.data[i].punitario;

              let montoiva = mont;
              montoiva = montoiva * response.data[i].cantidad;

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                nombrecorto: response.data[i].nombrecorto,
                precio: precio,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                motoiva: montoiva,
                descuento: response.data[i].descuento,
                total: round(precio * response.data[i].cantidad, 2) + montoiva,
                totald: response.data[i].cantidad * precio,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: response.data[i].valormoneda,
                idmoneda: response.data[i].idmoneda,
                costoproveedor: response.data[i].punitario,
                tasa: tasa,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
              });
            }
            setRecords(prod);
            calcularTotalesReten(prod, rets);
            seleccionarRetenciones(id);
          } else {
            var prod = [];
            let rets = [];
            let uni = [];
            let precio = 0.0;

            for (let i = 0; i < response.data.length; i++) {

              if (parseInt(response.data[i].idunidadalterna) === 0) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let tasa = 0.0;

              if (operacion !== 1) {
                tasa = tasav;
              } else {
                tasa = response.data[i].valormoneda;
              }

              let mont = round((response.data[i].punitario * response.data[i].ivaventa) / 100, 2);

              precio = response.data[i].punitario;

              let montoiva = mont;
              montoiva = montoiva * response.data[i].cantidad;

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                nombrecorto: response.data[i].nombrecorto,
                precio: precio,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                motoiva: montoiva,
                descuento: response.data[i].descuento,
                total: response.data[i].cantidad * precio + montoiva,
                totald: response.data[i].cantidad * precio,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: response.data[i].valormoneda,
                idmoneda: response.data[i].idmoneda,
                costoproveedor: response.data[i].punitario,
                tasa: tasa,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
              });

            }
            setRecords(prod);
            calcularTotalesReten(prod, rets);
            //seleccionarRetenciones(response.data[0].idfacturacompra);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const retenciones = (id, tasa, idope) => {
    let endpoint = `${op.conexion}/api/retenciones/seleccionarretenciones?idfacturacompra=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let data = [];

            for (let i = 0; i < response.data.length; i++) {
              data.push({
                codigo: response.data[i].codigo,
                descripcion: response.data[i].descripcion,
                baseimponible: response.data[i].baseimponible,
                alicuota: response.data[i].alicuota,
                total: response.data[i].total,
                fecha: txtFecha.current.value,
                iva: response.data[i].iva,
                totalf: response.data[i].totalfactura,
                montoiva: response.data[i].totaliva,
                idtiporetencion: response.data[i].idtiporetencion,
                deducible: response.data[i].deducible,
                unidad: response.data.unidad,
              });
            }
            seleccionarDetalleFactura(
              response.data[0].idfacturacompra,
              data,
              tasa,
              idope
            );
          } else {
            seleccionarDetalleFactura(id, [''], tasa, idope);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRetenciones = (id) => {
    let endpoint = `${op.conexion}/api/retenciones/seleccionarretenciones?idfacturacompra=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let data = [];

            for (let i = 0; i < response.data.length; i++) {
              data.push({
                codigo: response.data[i].codigo,
                descripcion: response.data[i].descripcion,
                baseimponible: response.data[i].baseimponible,
                alicuota: response.data[i].alicuota,
                total: response.data[i].total,
                fecha: txtFecha.current.value,
                iva: response.data[i].iva,
                totalf: response.data[i].totalfactura,
                montoiva: response.data[i].totaliva,
                idtiporetencion: response.data[i].idtiporetencion,
                deducible: response.data[i].deducible,
                unidad: response.data[i].unidad,
              });
            }
            setDatosret(data);
            setDatareten(data);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Facturas de Compra.");
    setIdorden(0);
    setTipou(0);
    setRif(null);
    setTasaor(0);
    setIdmoney(0);
    setConsulp(true);
    setIndice(null);
    setDatosret([]);
    setDatareten([]);
    setDatosfact([]);
    setItems([]);
    setBody(null);
    setStatusordencompra(0);
    setIdCliente("");
    setIdAlmacen(0);
    setIdOpeInve("");
    setValalmacen(0);
    setValparametro("");
    setDesde(0);
    cmbRif.current.value = "";
    txtIdfactura.current.value = "";
    txtNombreCliente.current.value = "";
    txtCedRif.current.value = "";
    txtDirClient.current.value = "";
    txtTotal.current.value = "";
    txtTotalconIva.current.value = "";
    txtTotalIva.current.value = "";
    txtSubTotal.current.value = "";
    txtExento.current.value = "";
    txtCodigo.current.value = "";
    txtFecha.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    txtAfectaInventario.current.checked = false;
    txtTotalRetencion.current.value = "";
    txtNumControl.current.value = "";
    txtOrdenCompra.current.value = "";
    txtAlmacen.current.value = "";
    // Campo de captura de producto de la tabla: es un input no controlado,
    // por lo que se limpia explicitamente para no conservar el codigo anterior.
    if (txtCodigoProducto.current) txtCodigoProducto.current.value = "";
    // Los refs de las filas son arreglos: se vacian para no conservar
    // referencias a los inputs de la factura anterior.
    txtId.current = [];
    txtCantidad.current = [];
    txtPrecio.current = [];
    setActivate(false);
    setRecords([]);
    setAcpt(false);
    setComboMoneda([]);
    setHabilitarCat(true);
    setNumNota(null);
    setVisibleBtn("visible");
    setCastabla(true);
    setOperacion(0);
    setHabilitado(true);
    setHabilitadoNU(false);
    setMostrar(false);
    setCatalogoPresu(false);
    setCatalogoFactura(false);
    setCatalogoalmacen(false);
    setCatalogoCliente(false);
    setCatalogoMoneda(false);
    setCatregistrarcliente(false);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: false,
      cancelar: false,
      catalogo: true,
      catalogoper: true,
    });
    setMoneda({
      idmoneda: "4",
      descripcion: "DOLARES",
      simbolo: "$",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaSub({
      idmoneda: "2",
      descripcion: "DOLARES",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 0.0,
    });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);

    if (valparametro === "proveedor") {
      txtNombreCliente.current.value = values.nombre;
      txtDirClient.current.value = values.direccion;
      cmbRif.current.value = values.rif.substring(0, 1);
      setRif(values.rif.substring(0, 1));
      txtCedRif.current.value = values.rif.substring(1, 10);
      setIdCliente(values.idagente);
    }
  };

  const onCatalogo = (val) => {
    if (val === 1) {
      setValparametro("proveedor");
      setCatalogoCliente(true);
    }
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (txtCedRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Proveedor",
        icono: "informacion",
      });
      sigue = false;
      txtCedRif.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Número de Factura",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtNumControl.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Número de Control",
        icono: "informacion",
      });
      sigue = false;
      txtNumControl.current.focus();
    } else if (txtAlmacen.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Código de Almacen",
        icono: "informacion",
      });
      sigue = false;
      txtAlmacen.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancela.current.focus();
    }

    if (sigue) {
      var factucompra = [];
      var factucompradeta = [];
      var factuxfactucompra = [];
      var opeinv = [];
      var opeinvdet = [];
      var tasa = 0.0;

      tasa = monedaSub.valormoneda;

      factucompra.push({
        idfacturacompra:
          operacion === 1 && txtIdfactura.current.value !== null
            ? 0
            : operacion === 2
              ? txtIdfactura.current.value
              : txtIdfactura.current.value,
        numfactura: txtCodigo.current.value,
        numcontrol: txtNumControl.current.value.trim(),
        cedularif: rif + txtCedRif.current.value,
        subtotal: parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")),
        totaliva: parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")),
        montoretenido: parseFloat(txtTotalRetencion.current.value) > 0 ? parseFloat(txtTotalRetencion.current.value.replace(/\./g, "").replace(",", ".")) : 0.00,
        montototal: txtTotalRetencion.current.value !== '' ?
          round(parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")) + parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")) - parseFloat(txtTotalRetencion.current.value.replace(/\./g, "").replace(",", ".")), 2)
          : round(parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")) + parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")), 2),
        idproveedor: idCliente,
        fechafactura: txtFecha.current.value,
        idmoneda: idmoney,
        tasa: tasa,
        idordencompra: idorden !== null ? parseInt(idorden) : 0,
        status: 0,
        descripcion: 'REGISTRO DE LA FACTURA N° - ' + txtCodigo.current.value + ' - DEL PROVEEDOR - ' + txtNombreCliente.current.value,
        idalmacen: idalmacen,
        idusuario: idusuario,
        usuario: usuario
      });

      opeinv.push({
        idoperacioninventario:
          idOpeInve === null || idOpeInve === "" ? "0" : idOpeInve,
        tipooperacion: "INGRESO",
        idalmacenorigen: idalmacen,
        idalmacendestino: "",
        fecha: txtFecha.current.value,
        idmoneda: moneda.idmoneda,
        observacion: "COMPRA",
      });

      for (let i = 0; i < records.length; i++) {

        if (records[i].tipounidad === null || records[i].tipounidad === undefined) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la unidad de medida del producto " + records[i].nombrecorto,
            icono: "informacion",
          });
          return;
        }

        factucompradeta.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          punitario: records[i].precio,
          iva: records[i].iva,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
        });

        opeinvdet.push({
          idproducto: records[i].idproducto,
          nombre: records[i].nombre,
          cantidad: records[i].cantidad,
          precio: round(parseFloat(records[i].precio), 2),
          fechavencimiento: "",
          tipomovimiento: "COMPRA",
          fechatipomovimiento: txtFecha.current.value,
          numfactura: txtCodigo.current.value,
          idalmacen: idalmacen,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tipofactor: records[i].tipofactor,
          valorfactor: records[i].valorfactor,
        });
      }

      for (let i = 0; i < datosret.length; i++) {
        factuxfactucompra.push({
          codigo: datosret[i].codigo,
          baseimponible: datosret[i].baseimponible,
          alicuota: datosret[i].alicuota,
          total: datosret[i].total,
          codigofact: txtCodigo.current.value,
          totalfactura: datosret[i].totalf,
          iva: datosret[i].iva,
          totaliva: datosret[i].montoiva,
          unidad: datosret[i].unidad,
        });
      }

      setBody({
        factucompra: factucompra,
        factucompradeta: factucompradeta,
        factuxfactucompra: factuxfactucompra,
        idtipopeinv: "1",
        opeinv: opeinv,
        opeinvdet: opeinvdet,
        afinventario: txtAfectaInventario.current.checked
      });

      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "¿Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "¿Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "¿Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/retenciones/actualizarretenciones/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idpe + " Creado Correctamente!",
              icono: "exito",
            });
            imprimirOrdendeCompra(response.data.idpe);
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " +
                response.data.idpe +
                " Modificado Correctamente!",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idpe + " Eliminado Correctamente!",
              icono: "exito",
            });
          }

          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      var prod = records;
      setDesde(0);
      setRecords(prod);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
  };

  const onCambioMoneda = (values) => {
    var tasa = 0.0;
    var data = [...records];
    var ret = [...datosret];
    let precio = 0.0;
    let montoiva = 0.0;
    let precib = 0.0;
    let base = 0.0;
    let totalr = 0.0;

    if (operacion !== 4) {
      if (values.simbolo === "$") {
        setAcpt(false);
        setIdmoney(values.idmoneda);
      } else {
        setAcpt(true);
      }
    }

    for (let i = 0; i < data.length; i++) {

      if (data[i].idmoneda === values.idmoneda) {
        tasa = data[i].valormoneda;
      } else {
        tasa = values.valormoneda;
      }

      let montoiv = round((data[i].costoproveedor * data[i].iva) / 100, 2);

      precio = data[i].costoproveedor;
      precib = precio * data[i].valormoneda;
      precib = round(precib / tasa, 2);

      if (values.subpredeterminada === true) {
        montoiva = montoiv;
      } else {
        round(montoiva = montoiv * data[i].valormoneda, 2);
      }

      let totalivas = round(montoiva * data[i].cantidad, 2);

      data[i].precio = precib;
      data[i].total = round(precib * data[i].cantidad, 2) + totalivas;
      data[i].motoiva = montoiva * data[i].cantidad;
      data[i].totald = precib * data[i].cantidad;
    }

    for (let c = 0; c < ret.length; c++) {

      if (data[0].idmoneda === values.idmoneda) {
        base = round(ret[c].baseimponible, 2);
        base = base / values.valormoneda;

        totalr = round(ret[c].total, 2);
        totalr = totalr / values.valormoneda;
      } else {
        base = round(ret[c].baseimponible, 2);
        base = base / values.valormoneda;
        base = base * data[0].valormoneda;

        totalr = round(ret[c].total, 2);
        totalr = totalr / values.valormoneda;
        totalr = totalr * data[0].valormoneda;
      }

      ret[c].baseimponible = base;
      ret[c].total = totalr;
    }

    setRecords(data);
    calcularTotalesReten(data, ret);
  };

  const onCambioMonedados = (values) => {
    var tasa = 0.0;
    var data = [...records];
    var ret = [...datosret];
    let precio = 0.0;
    let montoiva = 0.0;
    let precib = 0.0;
    let base = 0.0;
    let totalr = 0.0;

    if (operacion !== 4) {
      if (values === "1") {
        setAcpt(false);
      } else {
        setAcpt(true);
      }
    }

    if (values === "1") {
      tasa = 1.0;
    } else {
      tasa = tasaor;
    }

    for (let i = 0; i < data.length; i++) {

      let montoiv = round((data[i].costoproveedor * data[i].iva) / 100, 2);

      precio = data[i].costoproveedor;
      precib = precio * tasaor;
      precib = round(precib / tasa, 2);

      if (values === '1') {
        montoiva = round(montoiv * tasaor, 2);
      } else {
        montoiva = montoiv;
      }

      let totalivas = round(montoiva * data[i].cantidad, 2);

      data[i].precio = precib;
      data[i].total = round(precib * data[i].cantidad, 2) + totalivas;
      data[i].motoiva = montoiva * data[i].cantidad;
      data[i].totald = precib * data[i].cantidad;
    }

    for (let c = 0; c < ret.length; c++) {
      if (values !== "1") {
        base = ret[c].baseimponible;
        base = base;

        totalr = ret[c].total;
        totalr = totalr;
      } else {
        base = ret[c].baseimponible;
        base = base * tasaor;

        totalr = ret[c].total;
        totalr = totalr * tasaor;
      }

      ret[c].baseimponible = base;
      ret[c].total = totalr;
    }
    setRecords(data);
    calcularTotalesReten(data, ret);
  };

  const validarCantidad = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "1,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "cantidad") {
        var canti = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let data = [...records];
        let info = [];

        let montoiv = (data[index].precio * data[index].iva) / 100;

        let ivss = round(montoiv * canti, 2);

        data[index].cantidad = canti;
        data[index].motoiva = ivss;
        data[index].total = data[index].precio * canti + ivss;
        data[index].totald = data[index].precio * canti;

        let subtot = 0.0,
          totalm = 0.0,
          toivss = 0.0;
        let totalexento = 0.00;

        for (let i = 0; i < data.length; i++) {
          toivss = parseFloat(toivss) + data[i].motoiva;
          subtot = parseFloat(subtot) + data[i].totald;
          if (parseInt(data[i].iva) === 0) {
            totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
          }
        }

        totalm = subtot + toivss;


        if (totalm > 0) {
          txtSubTotal.current.value = formatMoneda(
            subtot.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtExento.current.value = formatMoneda(
            totalexento.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtTotalIva.current.value = formatMoneda(
            toivss.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtTotalconIva.current.value = formatMoneda(
            totalm.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtTotal.current.value = formatMoneda(
            totalm.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        setRecords(data);

        if (
          operacion === 2 &&
          parseFloat(txtTotalRetencion.current.value) > 0.00
        ) {
          info.push({
            base: txtSubTotal.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            iva: data[index].iva,
            montoiva: txtTotalIva.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
          });
          setDatosfact(info);
        } else if (operacion === 1 && datosret.length > 0) {
          let ret = [...datosret];

          info.push({
            base: txtSubTotal.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            iva: data[index].iva,
            montoiva: txtTotalIva.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
            id: ret.length > 0 ? ret[0].codigo : "",
            unidad: ret[0].unidad,
          });
          setDatosfact(info);
        } else {
          let ddt = [];
          ddt.push({
            base: subtot,
            iva: data[index].iva,
            montoiva: toivss,
            totalc: totalm,
          });
          setItems(ddt);
        }

        if (event.which === 13) {
          if (index < data.length - 1) {
            setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPrecio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "1,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "precio") {
        let data = [...records];
        let info = [];

        var preci = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let montoiv = round((preci * data[index].iva) / 100, 2);
        let ivss = montoiv * data[index].cantidad;

        data[index].precio = preci;
        data[index].motoiva = ivss;
        data[index].total = preci * data[index].cantidad + ivss;
        data[index].totald = preci * data[index].cantidad;

        let subtot = 0.0,
          totalm = 0.0,
          toivss = 0.0;
        let totalexento = 0.00;

        for (let i = 0; i < data.length; i++) {
          toivss = parseFloat(toivss) + data[i].motoiva;
          subtot = parseFloat(subtot) + data[i].totald;

          if (parseInt(data[i].iva) === 0) {
            totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
          }
        }

        totalm = subtot + toivss;
        txtSubTotal.current.value = formatMoneda(
          subtot.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        txtExento.current.value = formatMoneda(
          totalexento.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        txtTotalIva.current.value = formatMoneda(
          toivss.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        txtTotalconIva.current.value = formatMoneda(
          totalm.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        txtTotal.current.value = formatMoneda(
          totalm.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );

        setRecords(data);
        if (operacion === 2 && txtTotalRetencion.current.value > 0.00) {
          info.push({
            base: txtSubTotal.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            iva: data[index].iva,
            montoiva: txtTotalIva.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
          });
          setDatosfact(info);
        } else if (operacion === 1 && datosret.length > 0) {
          let ret = [...datosret];
          info.push({
            base: txtSubTotal.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            iva: data[index].iva,
            montoiva: txtTotalIva.current.value
              .replace(/\./g, "")
              .replace(",", "."),
            totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
            id: ret.length > 0 ? ret[0].codigo : "",
          });
          setDatosfact(info);
        } else {
          let ddt = [];
          ddt.push({
            base: subtot,
            iva: data[index].iva,
            montoiva: toivss,
            totalc: totalm,
          });
          setItems(ddt);
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const BaseRetencion = (retencion, n, p) => {
    /**
     * Cuando no hay retenciones que aplicar (factura sin retenciones, o
     * ninguna retencion coincide con los codigos/unidades que calcula la
     * tabla de retenciones) no existe monto que descontar: el total debe
     * quedar en su valor bruto (subtotal + iva) y el monto retenido en
     * cero. Antes se sobreescribian ambos montos con 0,00.
     */
    if (Array.isArray(retencion) && retencion.length === 0) {
      setDatosret(retencion);
      txtTotalRetencion.current.value = "";

      let subtot = parseFloat(
        txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")
      );
      let toivss = parseFloat(
        txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")
      );

      if (!isNaN(subtot) && !isNaN(toivss)) {
        let mtotal = round(subtot + toivss, 2);

        txtTotal.current.value = formatMoneda(
          mtotal.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }

      return;
    }

    let total = 0.0;
    let mtotal = 0.0;
    let resta = 0.0;
    let montr = txtTotalRetencion.current.value
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    let val = p === undefined ? 0 : p;
    let dats = n === undefined ? [] : n;
    let mt = 0.0;

    if (operacion === 2 && val === 7) {
      mt = n[0].total;
      let ret = txtTotalRetencion.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      let tot = txtTotal.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      mtotal = round(parseFloat(tot), 2) + round(parseFloat(mt), 2);
      total = parseFloat(ret) - parseFloat(mt);
    } else {
      if (val !== 0) {
        let totalm = txtTotal.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", ".");

        for (let i = 0; i < dats.length; i++) {
          resta = parseFloat(resta) + n[i].total;
          mtotal = parseFloat(totalm) + round(parseFloat(n[i].total), 2);
        }

        total = montr - resta;
      } else {
        let totalm = txtTotal.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", ".");

        for (let i = 0; i < retencion.length; i++) {
          if (operacion === 1 && n === 5) {
            total = parseFloat(montr) + parseFloat(retencion[i].total);
          } else {
            total = parseFloat(total) + parseFloat(retencion[i].total);
          }

          if (n !== 4) {
            mtotal = round(parseFloat(totalm), 2) - round(parseFloat(retencion[i].total), 2);
          } else {
            mtotal = round(parseFloat(totalm), 2) - round(total, 2);
          }
        }
      }
    }
    setDatosret(retencion);
    txtTotalRetencion.current.value = formatMoneda(
      total.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotal.current.value = formatMoneda(
      mtotal.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const calcularTotalesReten = (data, ret) => {
    let datos = [];
    let subtot = 0.0,
      totr = 0.0,
      totalm = 0.0,
      toivss = 0.0, totalexento = 0.0;

    for (let c = 0; c < ret.length; c++) {
      totr = parseFloat(totr) + parseFloat(ret[c].total);
    }

    for (let i = 0; i < data.length; i++) {
      toivss = parseFloat(toivss) + data[i].motoiva;
      subtot = parseFloat(subtot) + data[i].totald;

      if (parseInt(data[i].iva) === 0) {
        totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
      }
    }

    let totalciv = 0.0;

    if (totr > 0) {
      totalm = round(subtot, 2) + round(toivss, 2) - round(totr, 2);
    } else {
      totalm = subtot + toivss;
    }

    totalciv = subtot + toivss;

    txtSubTotal.current.value = formatMoneda(
      subtot.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtExento.current.value = formatMoneda(
      totalexento.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotalIva.current.value = formatMoneda(
      toivss.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotalRetencion.current.value = totr > 0 ? formatMoneda(
      totr.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    ) : '';
    txtTotalconIva.current.value = formatMoneda(
      totalciv.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotal.current.value = formatMoneda(
      totalm.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    datos.push({
      base: subtot,
      iva: data[0].iva,
      montoiva: toivss,
      totalc: totalm,
    });
    setItems(datos);
  };

  const calcularTotales = (data) => {
    let datos = [];
    let subtot = 0.0,
      totalm = 0.0,
      toivss = 0.0;
    let totalexento = 0.00;

    for (let i = 0; i < data.length; i++) {
      toivss = parseFloat(toivss) + data[i].motoiva;
      subtot = parseFloat(subtot) + parseFloat(data[i].totald);

      if (parseInt(data[i].iva) === 0) {
        totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
      }
    }

    totalm = subtot + toivss;
    txtSubTotal.current.value = formatMoneda(
      subtot.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtExento.current.value = formatMoneda(
      totalexento.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotalIva.current.value = formatMoneda(
      toivss.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotalconIva.current.value = formatMoneda(
      totalm.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotal.current.value = formatMoneda(
      totalm.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    datos.push({
      base: subtot,
      iva: data[0].iva,
      montoiva: toivss,
      totalc: totalm,
    });
    setItems(datos);
  };

  const onCatalogoMoneda = (values) => {
    setCatalogoMoneda(false);
    setMoneda(values);
    onCambioMoneda(values);
  };

  const onRegistrarClientes = () => {
    setCatregistrarcliente(false);
  };

  const onBotones = (op) => (e) => {
    if (op === 1) {
      if (
        accbtnfactucompra &&
        accbtnfactucompra.toString().substring(0, 1) === "1"
      ) {
        // Cada factura nueva debe iniciarse con el formulario totalmente
        // limpio, sin datos de la factura registrada previamente.
        blanquear();
        setVisibleBtn("hidden");
        setTituloHeader("Incluir Factura de Compra.");
        setHabilitado(false);
        seleccionarMonedas();
        setCastabla(false);
        setConsulp(false);
        setHabilitarCat(false);
        setOperacion(1);
        setAcpt(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
        txtAfectaInventario.current.checked = true;
        setTimeout(() => txtCodigo.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnfactucompra &&
        accbtnfactucompra.toString().substring(1, 2) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Editar Factura de Compra.");
        setHabilitado(false);
        seleccionarMonedas();
        setHabilitarCat(true);
        setConsulp(true);
        setCastabla(false);
        setAcpt(false);
        setOperacion(2);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtAfectaInventario.current.checked = false;
        setTimeout(() => txtCodigo.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnfactucompra &&
        accbtnfactucompra.toString().substring(3, 4) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Eliminar Factura de Compra.");
        setConsulp(true);
        setHabilitado(false);
        seleccionarMonedas();
        setAcpt(false);
        setHabilitarCat(true);
        setCastabla(true);
        setOperacion(3);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtAfectaInventario.current.checked = false;
        setTimeout(() => txtCodigo.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnfactucompra &&
        accbtnfactucompra.toString().substring(2, 3) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Consultar Factura de Compra.");
        setConsulp(true);
        seleccionarMonedas();
        setAcpt(true);
        setHabilitado(false);
        setCastabla(true);
        setOperacion(4);
        setHabilitarCat(true);
        setHabilitadoNU(true);
        setDesde(7);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtAfectaInventario.current.checked = false;
        setTimeout(() => txtCodigo.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
      setOperacion(0);
    }
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            if (operacion === 1) {
              txtAfectaInventario.current.checked = true;
            }
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setIdmoney(response.data[i].idmoneda);
              }
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    setMoneda(combomoneda[i]);
    onCambioMoneda(combomoneda[i]);
  };

  const onChangeMonedaAn = (e) => {
    let i = e.target.value;
    onCambioMonedados(i);
  };

  const seleccionarOp = (numfact, idalmacen) => {
    let campos = "*";
    let nomtab = "operacioninventariodetalle";
    let nomid = "numfactura";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${numfact}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            seleccionarAlmacen(response.data.idalmacen, 7);
          } else {
            seleccionarAlmacen(idalmacen, 7);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMoneda = (id) => {
    let campos = "*";
    let nomtab = "moneda";
    let nomid = "idmoneda";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setMoneda(response.data);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProveedor = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "proveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${rif}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            cmbRif.current.value = response.data.rif.substring(0, 1);
            txtCedRif.current.value = response.data.rif.substring(1, 10);
            txtNombreCliente.current.value = response.data.nombre;
            txtDirClient.current.value = response.data.direccion;
            setRif(response.data.rif.substring(0, 1));
            setIdCliente(response.data.idagente);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            cmbRif.current.value = "";
            txtCedRif.current.value = "";
            txtNombreCliente.current.value = "";
            txtDirClient.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "ordendecompra";
    let nomid = "codigo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.status === 0) {
              txtFecha.current.value = moment(response.data.fecha).format(
                "YYYY-MM-DD"
              );
              txtCedRif.current.value = response.data.cedularif;
              txtOrdenCompra.current.value = response.data.codigo;
              seleccionarProveedor(response.data.cedularif);
              seleccionarMoneda(response.data.idmoneda);
              setIdorden(response.data.idordendecompra);
              seleccionarDetalleOrdenCompra(response.data.idordendecompra);
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "Esta Orden de Compra ya fue Fácturada!.",
                icono: "informacion",
              });
              txtOrdenCompra.current.value = "";
              txtOrdenCompra.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No Existe Orden de Compra con este Código!.",
              icono: "error",
            });
            txtOrdenCompra.current.value = "";
            txtOrdenCompra.current.focus();
            txtFecha.current.value = "";
            txtCedRif.current.value = "";
            txtNombreCliente.current.value = "";
            txtDirClient.current.value = "";
            txtSubTotal.current.value = "";
            txtTotalIva.current.value = "";
            txtTotalconIva.current.value = "";
            txtTotalRetencion.current.value = "";
            txtTotal.current.value = "";
            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistroFactura = (numfactura) => {
    let campos = "*";
    let nomtab = "facturacompra";
    let nomid = "numfactura";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${numfactura}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let tasa = response.data.tasa;
            setTasaor(response.data.tasa);
            txtFecha.current.value = moment(response.data.fechafactura).format(
              "YYYY-MM-DD"
            );
            setNumNota(response.data.codigo);
            txtCedRif.current.value = response.data.cedularif;
            txtCodigo.current.value = response.data.numfactura;
            txtNumControl.current.value = response.data.numcontrol;
            txtIdfactura.current.value = response.data.idfacturacompra;
            setIdOpeInve(response.data.idoperacioninventario);
            seleccionarProveedor(response.data.cedularif);
            setStatusordencompra(1);
            setIdAlmacen(response.data.idalmacen);
            if (operacion === 3) {
              setIdorden(response.data.idordencompra);
            } else {
              setIdorden(null);
            }

            if (parseInt(response.data.idoperacioninventario) > 0) {
              txtAfectaInventario.current.checked = true;
            } else {
              txtAfectaInventario.current.checked = false;
            }

            seleccionarMoneda(response.data.idmoneda);
            retenciones(response.data.idfacturacompra, tasa, response.data.idoperacioninventario);
            seleccionarOp(response.data.codigo, response.data.idalmacen);

          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No Existe una Fáctura con este Código!.",
              icono: "informacion",
            });
            txtCodigo.current.value = "";
            txtCodigo.current.focus();
            txtNumControl.current.value = "";
            txtAlmacen.current.value = "";
            txtFecha.current.value = "";
            txtCedRif.current.value = "";
            txtNombreCliente.current.value = "";
            txtDirClient.current.value = "";
            txtSubTotal.current.value = "";
            txtTotalIva.current.value = "";
            txtTotalconIva.current.value = "";
            txtTotalRetencion.current.value = "";
            txtTotal.current.value = "";
            txtExento.current.value = "";
            txtAfectaInventario.current.checked = false;
            setRecords([]);
            // Al no encontrar la factura no deben quedar retenciones ni
            // identificadores de la consulta anterior.
            setDatosret([]);
            setDatareten([]);
            setDatosfact([]);
            setItems([]);
            setIndice(null);
            setIdOpeInve("");
            setIdCliente("");
            setIdAlmacen(0);
            setValalmacen(0);
            setStatusordencompra(0);
            setIdorden(null);
            setTasaor(0);
            txtIdfactura.current.value = "";
            setNumNota(null);
            cmbRif.current.value = "";
            setRif(null);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idordendecompra") {
          seleccionarRegistro(event.target.value);
        }
      }
    }
  };

  const handleInputNumeroFactura = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "codigo") {
          seleccionarRegistroFactura(event.target.value);
        }
      }
    }
  };

  const handleInputAlmacen = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "almacen") {
          seleccionarAlmacen(event.target.value);
        }
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "cmbrif") {
      setRif(e.target.value);
    }
  };

  const handleCliente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (rif !== null) {
          seleccionarProveedor(rif + event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Tipo de Nacionalidad!.",
            icono: "informacion",
          });
        }
      }
    }
  };

  const onCatalogoPresupuesto = (values) => {
    setCatalogoPresu(false);
    seleccionarRegistro(values.codigo);
    setIdorden(values.idordendecompra);
  };

  const onCatalogoFacturaCompra = (values) => {
    setCatalogoFactura(false);
    txtCodigo.current.value = values.numfactura;
    seleccionarRegistroFactura(values.numfactura);
  };

  const onCatalogoAlmacen = (values) => {
    setCatalogoalmacen(false);
    txtAlmacen.current.value = values.idalmacen;
    setIdAlmacen(values.idalmacen);
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  const imprimirOrdendeCompra = (id) => {
    if (
      accbtnfactucompra &&
      accbtnfactucompra.toString().substring(4, 5) === "1"
    ) {
      if (txtCodigo.current.value !== "") {
        let reporte = "FacturadeCompra";
        let desdec = "'" + "'";
        let hastac = "'" + "'";
        let idfactu = operacion === 1 ? id : txtIdfactura.current.value;
        let condicion = "'" + 'n.idfacturacompra = ' + "'" + '||quote_literal(' + "'" + idfactu + "'" + ')';
        let orden = "'" + 'n.fechafactura' + "'";
        let oper = 2;

        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&ope=" + oper + "&orden=" + orden, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onCambioUnidad = (index) => (event) => {
    var data = [...records];
    let tipounidad = 0;

    if (event.target.value !== "") {
      let factor = parseFloat(data[index].valorfactor);
      if (isNaN(factor) || factor <= 0) {
        factor = 1.0;
      }

      // Costo del proveedor por unidad de medida (base del precio de la fila)
      let costo = parseFloat(data[index].costoproveedor);
      let precioactual = parseFloat(data[index].precio);
      let tipounidadactual = parseInt(data[index].tipounidad) === 1 ? 1 : 0;

      if (isNaN(costo) || costo <= 0) {
        costo = isNaN(precioactual) ? 0.0 : precioactual;
      }

      // Factor de conversion de moneda que ya tiene aplicado el precio actual:
      // precio = costo / (valorfactor, cuando es unidad alterna) * conversion
      let conversion = 1.0;
      if (costo > 0 && !isNaN(precioactual)) {
        conversion =
          tipounidadactual === 1
            ? (precioactual * factor) / costo
            : precioactual / costo;
      }
      if (isNaN(conversion) || conversion <= 0) {
        conversion = 1.0;
      }

      let precio = 0.0;

      if (parseInt(event.target.value) === parseInt(data[index].idunidadmedida)) {
        // Unidad de medida
        tipounidad = 0;
        precio = costo * conversion;
      } else {
        // Unidad alterna
        tipounidad = 1;
        precio = (costo / factor) * conversion;
      }

      precio = round(precio, 2);

      let cantidad = parseFloat(data[index].cantidad);
      if (isNaN(cantidad)) {
        cantidad = 0.0;
      }

      let montoiva = round((precio * data[index].iva) / 100, 2);

      // El arreglo de unidades no cambia: solo se marca cual esta activa
      data[index].precio = precio;
      data[index].tipounidad = tipounidad;
      data[index].motoiva = round(montoiva * cantidad, 2);
      data[index].totald = round(precio * cantidad, 2);
      data[index].total = round(data[index].totald + data[index].motoiva, 2);

      if (txtPrecio.current[index]) {
        txtPrecio.current[index].value = formatMoneda(
          precio.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    }

    calcularTotales(data);

    // Recalcula la base de las retenciones con los nuevos montos
    let subtot = 0.0,
      toivss = 0.0;

    for (let i = 0; i < data.length; i++) {
      toivss = parseFloat(toivss) + parseFloat(data[i].motoiva);
      subtot = parseFloat(subtot) + parseFloat(data[i].totald);
    }

    let totalm = subtot + toivss;

    if (operacion === 2 && parseFloat(txtTotalRetencion.current.value) > 0.0) {
      let info = [];
      info.push({
        base: subtot,
        iva: data[index].iva,
        montoiva: toivss,
        totalc: totalm,
      });
      setDatosfact(info);
    } else if (operacion === 1 && datosret.length > 0) {
      let ret = [...datosret];
      let info = [];
      info.push({
        base: subtot,
        iva: data[index].iva,
        montoiva: toivss,
        totalc: totalm,
        id: ret.length > 0 ? ret[0].codigo : "",
        unidad: ret.length > 0 ? ret[0].unidad : "",
      });
      setDatosfact(info);
    }

    setRecords(data);
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-1" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow ">
            <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-1">
              <div className="col-md-12 border-azul rounded py-1 row mx-auto mb-1 azulGradiant text-light justify-content-between">
                <div className="col-md-3">
                  <h3>{tituloHeader}</h3>
                </div>

                <div className="col-md-6 mx-auto row m-0">
                  <div
                    className="col-pd-350 py-1"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CODIGO COMPRA:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        name="idordendecompra"
                        onKeyUp={handleInputNumeroChange}
                        disabled={operacion !== 1 ? true : false}
                        ref={txtOrdenCompra}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        type="button"
                        onClick={() => setCatalogoPresu(true)}
                        disabled={habilitarCat}
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  {statusordencompra === 1 ? (
                    <div
                      className="col-p-195 py-1 ml-auto bg-light rounded"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <div className="input-group input-group-sm">
                        <select
                          className="form-control form-control-sm form-select fw-bold"
                          disabled={
                            operacion === 3 || operacion === 0 ? true : false
                          }
                          ref={txtIdmonedados}
                          onChange={onChangeMonedaAn}
                        >
                          <option value={1}>BOLIVARES 1,00 Bs</option>
                          <option value={2}>DOLAR $ = {tasaor} Bs</option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="col-p-195 py-1 ml-auto bg-light rounded"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <div className="input-group input-group-sm">
                        <select
                          className="form-control form-control-sm form-select fw-bold"
                          disabled={
                            operacion === 3 || operacion === 0 ? true : false
                          }
                          ref={txtIdmoneda}
                          onChange={onChangeMoneda}
                        >
                          {combomoneda &&
                            combomoneda.map((item, index) => (
                              <option key={index} value={index}>
                                {" "}
                                {`${item.descripcion} ${item.simbolo
                                  } ${formatMoneda(
                                    item.valormoneda
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}`}{" "}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-2 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>

              <fieldset className='row col-sm-5 mx-auto border-azul rounded mb-1'>
                <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.9rem' }}>DATOS DE LA FACTURA:</legend>

                <div className="col-12 px-1">
                  <div className="col-pd-200 px-1 ml-auto mt-5m mb-1">
                    <div class="form-check">
                      <input class="form-check-input" ref={txtAfectaInventario} onChange={onChange} disabled={operacion === 0 || operacion === 4 ? true : false} name="afectainventario" type="checkbox" value="" id="flexCheckChecked" />
                      <label class="form-check-label" for="flexCheckChecked">
                        ¿AFECTA INVENTARIO?
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 px-1 mb-2">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° FACTURA:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="hidden"
                      ref={txtIdfactura}
                    />
                    <input
                      autoComplete="off"
                      type="text"
                      name="codigo"
                      onKeyUp={handleInputNumeroFactura}
                      disabled={
                        operacion === 0 || operacion === 8 ? true : false
                      }
                      ref={txtCodigo}
                      className="form-control fs-6 bg-transparent"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      type="button"
                      onClick={() => setCatalogoFactura(true)}
                      disabled={
                        operacion === 1 || operacion === 0 || operacion === 8
                          ? true
                          : false
                      }
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-6 px-1 mb-2">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° CONTROL:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={castabla}
                      ref={txtNumControl}
                      className="form-control bg-transparent fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
                <div className="col-md-6 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      ALMACEN:
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={
                        castabla
                      }
                      className="form-control fs-6 text-uppercase"
                      ref={txtAlmacen}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputAlmacen}
                      name="almacen"
                    />
                    <button
                      type="button"
                      onClick={() => setCatalogoalmacen(true)}
                      disabled={
                        castabla
                      }
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-6 ml-auto px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA FACTURA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={castabla}
                      className="form-control fs-6 text-uppercase"
                      ref={txtFecha}
                      aria-label="Sizing example input"
                      defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </fieldset>

              <fieldset className='row col-sm-7 mx-auto border-azul rounded mb-1'>
                <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.9rem' }}>DATOS DEL PROVEEDOR:</legend>

                <div className="col-12 px-1">
                  <div className="col-pd-50 ml-auto mt-11m mb-1">
                    <button
                      style={{
                        pointerEvents:
                          botones.catalogoper === true ? "none" : false,
                        color: botones.catalogoper
                          ? "rgb(183, 183, 183)"
                          : "#1d0345",
                        backgroundColor: botones.catalogoper
                          ? "#fff"
                          : "transparent",
                      }}
                      type="button"
                      onClick={() => setCatregistrarcliente(true)}
                      className="btn btn-sm text-linght rounded-circle ml-2 bg-primary"
                      title="Registrar Proveedor"
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>
                </div>

                <div className="col-5 mb-2 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      disabled={consulp}
                      ref={cmbRif}
                      name="cmbrif"
                      onChange={onChange}
                      className="col-sm-3 col-3 form-select form-control-sm text-center"
                    >
                      <option value="">-</option>
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="J">
                        J
                      </option>
                      <option key="2" value="G">
                        G
                      </option>
                      <option key="3" value="P">
                        P
                      </option>
                      <option key="4" value="E">
                        E
                      </option>
                    </select>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={consulp}
                      maxLength={9}
                      ref={txtCedRif}
                      onKeyUp={handleCliente}
                      className="form-control fs-6 bg-transparent"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      type="button"
                      onClick={() => onCatalogo(1)}
                      style={{
                        pointerEvents:
                          botones.catalogoper === true ? "none" : false,
                      }}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="col-7 mb-2 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled
                      ref={txtNombreCliente}
                      className="form-control bg-transparent text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div className="col-12 mx-auto px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled
                      ref={txtDirClient}
                      className="form-control bg-transparent text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

              </fieldset>

              <div
                className="col-md-12 border-azul px-0 rounded row m-0"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 270,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden table-bordered">
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{ padding: "0", fontSizeAdjust: "0.6" }}
                        >
                          <TableCell className="bg-light">
                            <div className="row m-0">
                              <input
                                type="text"
                                style={{
                                  borderBottomRightRadius: 0,
                                  borderTopRightRadius: 0,
                                  maxWidth: 140
                                }}
                                disabled={castabla}
                                ref={(el) => (txtId.current[index] = el)}
                                className="form-control form-control-sm bg-light fs-6 text-uppercase col-10"
                                defaultValue={item.codigo}
                                onChange={(e) =>
                                  (e.target.value = e.target.value.toUpperCase())
                                }
                                onKeyUp={validarIdProductoM(index)}
                                onBlur={validarIdProductoM(index)}
                              />
                              {(operacion === 1 ||
                                operacion === 2) && (
                                  <button
                                    type="button"
                                    style={{
                                      borderBottomLeftRadius: 0,
                                      borderTopLeftRadius: 0,
                                    }}
                                    disabled={castabla}
                                    onClick={editarProducto(index)}
                                    className="btn btn-sm btn-primary col-2"
                                  >
                                    <i className="fas ">-</i>
                                  </button>
                                )}
                            </div>
                          </TableCell>

                          <TableCell
                            className="align-baseline bg-light"
                          >
                            {item.nombrecorto}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0"
                            style={{ width: "90px" }}
                          >
                            <input
                              type="text"
                              disabled={castabla}
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="cantidad"
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCantidad(index)}
                              onBlur={validarCantidad(index)}
                            />
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light p-0"
                            style={{ width: "110px" }}
                          >
                            <select
                              className="form-select form-select-sm fs-6"
                              disabled={castabla}
                              value={
                                parseInt(item.tipounidad) === 1 &&
                                  item.idunidadalterna
                                  ? item.idunidadalterna
                                  : item.idunidadmedida
                              }
                              onChange={onCambioUnidad(index)}
                              aria-label=".form-select-sm example"
                            >
                              {item.unidad &&
                                item.unidad.map((item2, x) => (
                                  <option key={x} value={item2.idunidad}>
                                    {" "}
                                    {item2.descripcion}{" "}
                                  </option>
                                ))}
                            </select>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "120px" }}
                          >
                            <input
                              type="text"
                              disabled={castabla}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              defaultValue={formatMoneda(
                                item.precio
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                            />
                            {/* {formatMoneda(item.precio.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-center"
                            style={{ width: "90px" }}
                          >
                            {formatMoneda(
                              item.iva
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-right"
                            style={{ width: "130px" }}
                          >
                            {formatMoneda(
                              item.motoiva
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light text-right"
                            style={{ width: "150px" }}
                          >
                            {formatMoneda(
                              item.total
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-baseline bg-light p-0"
                            style={{ textAlign: "center", width: "50px" }}
                          >
                            <button
                              disabled={castabla}
                              style={{
                                visibility:
                                  (operacion === 4 || operacion === 3) &&
                                  "collapse",
                              }}
                              className="btn btn-sm mx-1 btn-danger rounded-circle"
                              onClick={eliminarProducto(item)}
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    <TableRow
                      style={{
                        padding: "0",
                        visibility:
                          (operacion === 4 ||
                            operacion === 0 ||
                            operacion === 3 ||
                            operacion === 8 ||
                            (operacion === 2 && numNota === null)) &&
                          "collapse",
                      }}
                    >
                      <TableCell className="bg-light d-flex align-items-between px-0" style={{ maxWidth: '500px' }}>
                        <input
                          type="text"
                          ref={txtCodigoProducto}
                          style={{
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                          }}
                          className="form-control form-control-sm bg-light text-right fs-6 col-pd-150 text-uppercase"
                          onKeyUp={validarIdProducto}
                          onBlur={validarIdProducto}
                        />
                        <button
                          type="button"
                          style={{
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0,
                          }}
                          onClick={() => setMostrar(true)}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="fas ">-</i>
                        </button>
                      </TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                        style={{ textAlign: "center", width: "90px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "110px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "120px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-center"
                        style={{ width: "90px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-right"
                        style={{ width: "130px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light text-right"
                        style={{ width: "150px" }}
                      ></TableCell>
                      <TableCell
                        className="align-baseline bg-light"
                        style={{ width: "50px" }}
                      ></TableCell>
                    </TableRow>
                  </TableBody>
                </TblContainer>
              </div>
              <div
                className="col-md-12 py-1 border-azul rounded"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <span className="fw-bold">Datos de las Retenciones</span>
                <TablaRetenciones
                  datosfact={items}
                  op={opf}
                  baser={BaseRetencion}
                  renderiza={operacion}
                  render={datosfact}
                  datostabla={datareten}
                />
              </div>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-pd-full col-pd-9 mt-auto">

                  {visibleBtn === "visible" ? (
                    <div className="col-pd-650">
                      <div className="col-md-12 row m-0">
                        <button
                          disabled={botones.incluir}
                          onClick={onBotones(1)}
                          className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                          title="Incluir Almacen"
                        >
                          <i className="fas fa-plus"> Incluir </i>{" "}
                        </button>
                        <button
                          disabled={botones.consultar}
                          onClick={onBotones(4)}
                          className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                          title="Consultar Almacen"
                        >
                          <i className="fas fa-eye"> Consultar</i>{" "}
                        </button>
                        <button
                          disabled={botones.modificar}
                          onClick={onBotones(2)}
                          className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                          title="Modificar Almacen"
                        >
                          <i className="fa fa-edit"> Modificar</i>{" "}
                        </button>
                        <button
                          disabled={botones.eliminar}
                          onClick={onBotones(3)}
                          className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                          title="Eliminar Almacen"
                        >
                          <i className="fa fa-trash"> Eliminar</i>{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-pd-400 row m-0 ml-auto">
                      {habilitadoNU === true ? (
                        <div className="col-md-2">
                          <button
                            ref={btnAcepta}
                            onClick={imprimirOrdendeCompra}
                            disabled={
                              txtCodigo.current.value !== "" ? false : true
                            }
                            className="btn btn-sm rounded-circle btn-primary mb-1"
                          >
                            <i className="fas fa-print"></i>
                          </button>
                        </div>
                      ) : (
                        <div className="col-md-2"></div>
                      )}
                      <button
                        ref={btnAcepta}
                        disabled={acpt}
                        onClick={onChangeValidar}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        ref={btnCancela}
                        disabled={habilitado}
                        onClick={onBotones(6)}
                        className="btn btn-sm btn-danger col ml-1 rounded-pill"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="col-pd-full col-pd-3 border-azul rounded px-0 shadow"
                  style={{ backgroundColor: "#dbeeff", fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      SUBTOTAL: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtSubTotal}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm  col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      EXENTO: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtExento}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm  col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      IVA Sobre(16,00%): {moneda.simbolo} { }
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtTotalIva}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm  col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      TOTAL FACTURA: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtTotalconIva}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm  col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      TOTAL RETENIDO: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtTotalRetencion}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm  col-md-12">
                    <label
                      className="input-group-text bg-transparent border-0 fs-6"
                      id="inputGroup-sizing-sm"
                    >
                      TOTAL: {moneda.simbolo}
                    </label>

                    <input
                      type="text"
                      disabled
                      className="form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold"
                      placeholder="0,00"
                      ref={txtTotal}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      <CatalogoCliente
        show={catalogoCliente}
        nomid={valparametro}
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />

      <CatalogoMoneda
        show={catalogoMoneda}
        onHideCancelar={() => setCatalogoMoneda(false)}
        onHideAceptaCatalogo={onCatalogoMoneda}
      />

      <CatalogoProducto
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
      />

      <CatalogoOrdenCompras
        show={catalogoPresu}
        nomid="ordencompra"
        onHideCancelar={() => setCatalogoPresu(false)}
        onHideAceptaCatalogo={onCatalogoPresupuesto}
        condicion="true"
        op="7"
      />

      <CatalogoFacturasdCompra
        show={catalogoFactura}
        nomid="facturacompra"
        onHideCancelar={() => setCatalogoFactura(false)}
        onHideAceptaCatalogo={onCatalogoFacturaCompra}
        condicion="true"
      />

      <CatalogoAlmacen
        show={catalogoalmacen}
        onHideCancelar={() => setCatalogoalmacen(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />

      <RegistrarProveedor
        show={catregistrarcliente}
        op={operacion}
        onHideCancelar={() => setCatregistrarcliente(false)}
        onHideAceptaCatalogo={onRegistrarClientes}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div >
  );
};
export default TablaFacturarOrdenCompra;



// WEBPACK FOOTER //
// ./src/components/compra/tablaFacturaOrdenCompra.js